export {
  SpinnerBackgroundColor,
  SpinnerColor,
  SpinnerComponent,
  SpinnerSize,
  SpinnerType,
} from './spinner.component';
